
export const FETCH_WORKLIST = "[MIS] FETCH_WORKLIST";
export const FETCH_WORKLIST_START = "[MIS] FETCH_WORKLIST_START";
export const FETCH_WORKLIST_SUCCESS = "[MIS] FETCH_WORKLIST_SUCCESS";
export const FETCH_WORKLIST_ERROR = "[MIS] FETCH_WORKLIST_ERROR";
export const SET_WORKLIST_FILTER = "[MIS] SET_WORKLIST_FILTER";
export const REMOVE_LOCKED_VISIT = "[MIS] REMOVE_LOCKED_VISIT";

export const SET_WORKLIST_PAGINATION = "[MIS] SET_WORKLIST_PAGINATION";
export const SET_WORKLIST_AUTO_NEXT_VISIT = "[MIS] SET_WORKLIST_AUTO_NEXT_VISIT";

export const VIEW_WORKLIST_VISIT_LOADING_START = "[MIS] VIEW_WORKLIST_VISIT_LOADING_START";
export const VIEW_WORKLIST_VISIT_LOADING_END = "[MIS] VIEW_WORKLIST_VISIT_LOADING_END";

export const SET_WORKLIST_ALL_CASES_FILTER = "[MIS] SET_WORKLIST_ALL_CASES_FILTER";
export const RESET_WORKLIST_FILTER = "[MIS] RESET_WORKLIST_FILTER";

export const fetchMisWorklist = (payload) => {
    return {
        type: FETCH_WORKLIST,
        payload
    };
};

export const setMisWorklistfilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_WORKLIST_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const setWorklistAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_WORKLIST_AUTO_NEXT_VISIT,
        autoNextVisit
    }
}

export const setMisAllCasesfilter = (myCasesOnly) => {
    return {
        type: SET_WORKLIST_ALL_CASES_FILTER,
        payload: {
            myCasesOnly
        }
    };
}

export const resetWorklistFilter = () => {
    return {
        type: RESET_WORKLIST_FILTER,
    };
}